import Avatar from "./../../../../Images/face_co.svg"
import "./Intro.css"
import PropertyStatus from "../PropertyStatus/PropertyStatus"
import Aos from "aos"
import "aos/dist/aos.css"
import { useEffect } from "react"
export default function Intro(){
    useEffect(()=>{
        Aos.init({duration:800})
    },[])
    return (
        <div className="intro lg:mx-20 mx-5 mt-[5vh] h-full">
                
            <div className="intro-content lg:flex-row flex flex-col lg:w-[80%] xl:w-[60%] md:w-[50%] space-y-20 lg:space-x-20 mx-auto place-items-center">
                <div className="short-desc grow shrink basis-[300px]"  data-aos="fade-right">
                    <p className="text-center lg:text-left font-semibold text-5xl mb-5 about-me lg:pl-5 lg:border-l-4 border-b-4 pb-5 mx-auto lg:mx-0 border-orange-700 border-solid">About me</p>
                    <p className="leading-8 text-justify text-lg mb-3">Hi! My name is Kristof Molnar and I am first year CS student at Debrecen University in Hungary. I am curios person and I love to code. By the time I have gone throught lots if struggling but I here and thats good. My fingers are impatiently waiting for the offer. Apply me from freelancing to full-time job.</p>
                    <i className="font-medium">"Programming isn't about what you know; it's about what you can figure out.” - Chris Pine</i>
                </div>
                <div className="avatar-img shrink md:basis-[400px] mx-auto"  data-aos="fade-left">
                    <img src={Avatar} alt="" className="lg:w-[50vh]"/>
                    <PropertyStatus/>
                </div>
            </div>
        </div>
    )
}